import { NavigateFunction } from "react-router-dom";
import RootStore from "./RootStore";

export default class RouterStore {
    constructor(rootStore: RootStore, navigate: NavigateFunction) {
        this.rootStore = rootStore;
        this.navigate = navigate;
    }

    rootStore: RootStore;
    navigate: NavigateFunction
}